export { default, analyticsToThresholdCode } from './IndicatorColor'
